import { useRef } from 'react';
const useRallyFormRefs = () => {
    const titleTranslationsRefs = [
        ['titleDE', useRef(null)],
        ['titleEN', useRef(null)],
        ['titleCS', useRef(null)],
    ];
    const descriptionTranslationsRefs = [
        ['descriptionDE', useRef(null)],
        ['descriptionEN', useRef(null)],
        ['descriptionCS', useRef(null)],
    ];
    const orderedRefs = [
        ['themes', useRef(null)],
        ['internalTitle', useRef(null)],
        ...titleTranslationsRefs,
        ...descriptionTranslationsRefs,
        ['targetGroups', useRef(null)],
        ['badge', useRef(null)],
        ['minutes', useRef(null)],
    ];
    return { refs: Object.fromEntries(orderedRefs), orderedRefs };
};
export default useRallyFormRefs;
